import { FailedIcon2, SuccessIcon2 } from '@assets/icons';
import { CloseRedIcon } from '@assets/icons/index';
import { CloseIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, Text } from '@chakra-ui/react';
import ModalTemplate from '@components/modalTemplate';
import { useResyncModal } from '@pages/SelloutMonitoring/hooks/state/resyncModal';

export default function ResyncModal() {
    const { isOpen, onToggle, resyncData } = useResyncModal();
    const isError = resyncData?.status === 400;

    const config = {
        title: isError
            ? 'Resync Data Sellout Group Gagal'
            : `Sukses Resync ${resyncData.count?.success} dari ${resyncData.count?.total} Customer`,
        desc: isError ? 'Mohon perhatikan catatan di bawah ini.' : 'Perhatikan catatan di bawah ini.',
        color: isError ? 'danger.500' : 'success.600',
        Icon: isError ? FailedIcon2 : SuccessIcon2,
    };

    const errorDetails = resyncData?.detail ?? [];
    const errorMessage = resyncData?.message ? `${resyncData.message}:` : '';

    const handleClose = () => onToggle();

    return (
        <ModalTemplate isOpen={isOpen} width="520px" isClosebyOverlayClick={false}>
            <Box p="24px">
                <Flex justify="flex-end" mb="12px">
                    <CloseIcon w={7} h={7} p={2} cursor="pointer" onClick={handleClose} />
                </Flex>

                <Flex direction="column" align="center">
                    <config.Icon size={92} />

                    <Text fontWeight="600" fontSize="24px" textAlign="center" color={config.color}>
                        {config.title}
                    </Text>

                    <Text fontSize="14px" mb="16px">
                        {config.desc}
                    </Text>

                    <Box w="full" p="16px" bg="semantic.200" borderRadius="8px">
                        <Text fontWeight="bold" mb="16px">
                            Detail Masalah
                        </Text>

                        <Box bg="danger.100" p="12px" borderRadius="8px">
                            <Text fontWeight="bold" color="danger.500" mb="10px">
                                {errorMessage}
                            </Text>

                            <Box maxH="130px" overflowY="auto">
                                {errorDetails.map((item, i) => (
                                    <Flex
                                        key={i}
                                        alignItems="center"
                                        gap="8px"
                                        ms="12px"
                                        mb={i === errorDetails.length - 1 ? 0 : '10px'}
                                    >
                                        <CloseRedIcon fontSize="10px" />
                                        <Text fontSize={'12px'}>{item.name}</Text>
                                    </Flex>
                                ))}
                            </Box>
                        </Box>
                    </Box>

                    <Text fontSize="14px" my="16px">
                        Aktifkan fitur resync dengan masuk ke store config dan pilih POS Sync.
                    </Text>

                    <Button w="140px" fontWeight="normal" onClick={handleClose}>
                        Mengerti
                    </Button>
                </Flex>
            </Box>
        </ModalTemplate>
    );
}
